module.exports = __webpack_public_path__ + "img/welcome.a483349e.png";